import React from 'react';
import {
  Edit as EditIcon,
  MoreVert as MoreIcon
} from '@mui/icons-material';
import ActionBar from '../../../../components/card/ActionBar';
import ActionButton from '../../../../components/card/ActionButton';

const CardActionBar = ({
  onEditClick,
  onMenuOpen,
  tabType = 'draft'
}) => {
  // Only show edit button for draft content
  const showEditButton = tabType === 'draft';

  const handleMenuClick = (event) => {
    event.stopPropagation();
    onMenuOpen(event);
  };

  return (
    <ActionBar>
      {showEditButton && (
        <ActionButton
          icon={<EditIcon />}
          tooltipTitle="Edit"
          onClick={onEditClick}
        />
      )}
      <ActionButton
        icon={<MoreIcon />}
        tooltipTitle="More options"
        onClick={handleMenuClick}
        ariaLabel="more options"
      />
    </ActionBar>
  );
};

export default CardActionBar;